import * as M from './messages';

export const tableBodyData_MM = [
  {
    leftCol: M.defined.small,
    rightCol: M.defined.smallSize,
  },
  {
    leftCol: M.defined.standard,
    rightCol: M.defined.standardSize,
  },
  {
    leftCol: M.defined.large,
    rightCol: M.defined.largeSize,
  },
];

export const tableBodyData_INCH = [
  {
    leftCol: M.defined.small,
    rightCol: M.defined.smallSizeInch,
  },
  {
    leftCol: M.defined.standard,
    rightCol: M.defined.standardSizeInch,
  },
  {
    leftCol: M.defined.large,
    rightCol: M.defined.largeSizeInch,
  },
];
